<template>
    <div>
        <div class="flex items-center justify-between my-4">
            <div class="flex items-center justify-space-between">
                <div class="flex items-center">
                    <WarningIcon class="text-primary-light w-10 mr-1" />
                    <h1 class="text-black text-xl lg:text-2xl">Practices Requiring Action</h1>
                </div>
            </div>
            <!-- <h1 class="text-black text-lg lg:text-2xl">Comparative Report</h1> -->
        </div>  
        <div class="c-alert__table editable_table flex flex-col w-full border-none">
            <v-data-table
                single-select
                :headers="headers"
                :items="stats.actionPlanDue.list"
                :items-per-page="5"
                :item-class="() => 'cursor-pointer'"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :footer-props="footerProps"
                :no-data-text="emptyText"
                :no-results-text="emptyText"
                class="a-table w-full"
                @click:row="rowClickHandler"
            >
            <template v-slot:[`item.redirect`]="{ item }">
                <div
                    class="text-right tablet-hide"
                    :class="{'active-tr': item.active}"
                >
                    <a
                        href="#"
                        @click.prevent="rowClickHandler(item)"
                        class="hover:text-primary mx-2"
                    >
                        <fa-icon icon="chevron-right" class="text-grey-2 ml-3" />
                    </a>
                </div>
            </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import WarningIcon from '@/assets/icons/icons_warning.svg'

export default {
    name: 'PracticesRequiringAction',
    components: { WarningIcon },
    data() {
        return {    
            emptyText: 'Not found',
            headers: [
                { text: 'Practice', align: 'left', value: 'practiceName', class: 'w-150 count--header' },
                { text: 'Total', align: 'left', value: 'numTotalNonconform', class: 'w-250 count--header' },
                { text: 'Open', align: 'left', value: 'numOpenNonconform', class: 'w-150 count--header' },
                { text: 'Closed', align: 'left', value: 'numClosedNonconform', class: 'w-250 count--header',sortable: false },
                { text: '', align: 'left', value: 'redirect', fixed: true, sortable: false},
            ],
            footerProps: {
                'items-per-page-text':'',
                'items-per-page-options': [5, 10, 20, 30, 40],
                showFirstLastPage: true
            },
            sortBy: 'numOpenNonconform',
            sortDesc: true,
        }
    },
    props: {
        stats: {
            type: Object,
            default: () => {
            }
        }
    },
    methods: {
        rowClickHandler(obj, e) {
            const url = this.$router
                .resolve({
                    name: 'Assessment', 
                    params: {id: obj.practiceId, assessmentId: obj.assessmentId.toString()}
                })
            window.open(url.href, '_blank')
        },     
    }
}
</script>